import React from "react";
import SearchInput from "../../common/Search";
import { SrPumps, DrCables, DrGasHandlers, DrGasSeparators, DrMotorLeads, DrMotorSensors, DrMotors, DrProtectors, DrPumps, DrSwitchBoard, DrVSD, SrAccAboveESP, SrAccBelowESP, SrBOH, SrCables, SrGasHandlers, SrGasSeparators, SrMLE, SrMotors, SrProtectors, SrTransformers, SrVSDs, HarmonicFilters } from "../../../constants/columns/equipment-catalog/equipmentCatalog";
import InfiniteScrollTable from "../../common/infinite-scroll";
import { useAppSelector } from "../../../store/hooks/StoreHooks";
import { CatalogType } from "../../../store/model/equipment-catalog/catalog";

interface IMyProjects {
    setCurrentParams?: any;
    currentParams?: any;
};

const Catalog: React.FC<IMyProjects> = ({
    currentParams,
    setCurrentParams,
}) => {
    const {
        loading,
        dropdownOption,
        catalog,
    } = useAppSelector((state) => state?.equipmentCatalog);

    const handleSortChange = (order: string, field: string): void => {
        if (order === "none") {
            setCurrentParams((prev: any) => ({
                ...prev,
                SortDto: { Field: "", Order: "" },
                PageNumber: 1,
                PageSize: 10,
            }));
        } else {
            setCurrentParams((prev: any) => ({
                ...prev,
                SortDto: { Field: field, Order: order },
                PageNumber: 1,
                PageSize: 10
            }));
        }
    };

    const handleSearchChange = (
        e: React.ChangeEvent<HTMLInputElement> | string
    ): void => {
        if (typeof e === "string") {
            setCurrentParams((prev: any) => ({
                ...prev,
                GlobalFilter: e,
                PageNumber: 1,
                PageSize: 10,
            }));
        } else {
            setCurrentParams((prev: any) => ({
                ...prev,
                GlobalFilter: e?.target?.value,
                PageNumber: 1,
                PageSize: 10,
            }));
        }
    };

    const loadMore = () => {
        if (currentParams?.PageSize < catalog?.count) {
            setCurrentParams((prev: any) => {
                return ({
                    ...prev,
                    PageSize: prev?.PageSize + 10,

                })
            });
        }
    };

    return (
        <div className="w-full flex-1 gap-[16px] border-[1px] rounded-lg border-darkcolor-400 bg-darkcolor-700">
            <div className="w-full flex px-[24px] py-[20px] border-b border-darkcolor-400 text-[18px] text-neutral-25 font-semibold">
                Equipment catalog
            </div>
            <div className="w-full flex-1 px-[24px] pt-[12px] pb-[20px]">
                <div className="flex flex-col md:flex-row justify-between items-center mb-[12px] space-y-4 md:space-y-0">
                    <div className="flex items-center justify-end w-full md:w-auto order-1 md:order-2">
                        <SearchInput
                            searchValue={currentParams?.GlobalFilter}
                            onSearchChange={handleSearchChange}
                            placeholder={"Search"}
                            bgColor="bg-darkcolor-800"
                            width={400}
                        />
                    </div>

                    <div className="flex items-center justify-start order-2 md:order-1 text-neutral-25">
                        {`Showing ${catalog?.data?.length} out of ${catalog?.count}`}
                    </div>
                </div>
                {dropdownOption?.id === CatalogType?.DRCables?.toString() && (
                    <InfiniteScrollTable
                        data={catalog?.data || []}
                        columns={[...DrCables]}
                        onLoadMore={() => loadMore()}
                        rowsPerPage={1}
                        minimumHeight={300}
                        totalCount={catalog?.count}
                        overFlowClass="overflow-auto"
                        handleSortChange={handleSortChange}
                        initialSortField={currentParams?.SortDto?.Field}
                        initialSortOrder={currentParams?.SortDto?.Order}
                        isLoading={loading}
                    />
                )}
                {dropdownOption?.id === CatalogType?.DRGasHandlers?.toString() && (
                    <InfiniteScrollTable
                        data={catalog?.data || []}
                        columns={[...DrGasHandlers]}
                        onLoadMore={() => loadMore()}
                        rowsPerPage={1}
                        minimumHeight={300}
                        totalCount={catalog?.count}
                        overFlowClass="overflow-auto"
                        handleSortChange={handleSortChange}
                        initialSortField={currentParams?.SortDto?.Field}
                        initialSortOrder={currentParams?.SortDto?.Order}
                        isLoading={loading}
                    />
                )}
                {dropdownOption?.id === CatalogType?.DRGasSeparators?.toString() && (
                    <InfiniteScrollTable
                        data={catalog?.data || []}
                        columns={[...DrGasSeparators]}
                        onLoadMore={() => loadMore()}
                        rowsPerPage={1}
                        minimumHeight={300}
                        totalCount={catalog?.count}
                        overFlowClass="overflow-auto"
                        handleSortChange={handleSortChange}
                        initialSortField={currentParams?.SortDto?.Field}
                        initialSortOrder={currentParams?.SortDto?.Order}
                        isLoading={loading}
                    />
                )}
                {dropdownOption?.id === CatalogType?.DRMotorLeads?.toString() && (
                    <InfiniteScrollTable
                        data={catalog?.data || []}
                        columns={[...DrMotorLeads]}
                        onLoadMore={() => loadMore()}
                        rowsPerPage={1}
                        minimumHeight={300}
                        totalCount={catalog?.count}
                        overFlowClass="overflow-auto"
                        handleSortChange={handleSortChange}
                        initialSortField={currentParams?.SortDto?.Field}
                        initialSortOrder={currentParams?.SortDto?.Order}
                        isLoading={loading}
                    />
                )}
                {dropdownOption?.id === CatalogType?.DRMotorSensors?.toString() && (
                    <InfiniteScrollTable
                        data={catalog?.data || []}
                        columns={[...DrMotorSensors]}
                        onLoadMore={() => loadMore()}
                        rowsPerPage={1}
                        minimumHeight={300}
                        totalCount={catalog?.count}
                        overFlowClass="overflow-auto"
                        handleSortChange={handleSortChange}
                        initialSortField={currentParams?.SortDto?.Field}
                        initialSortOrder={currentParams?.SortDto?.Order}
                        isLoading={loading}
                    />
                )}
                {dropdownOption?.id === CatalogType?.DRMotors?.toString() && (
                    <InfiniteScrollTable
                        data={catalog?.data || []}
                        columns={[...DrMotors]}
                        onLoadMore={() => loadMore()}
                        rowsPerPage={1}
                        minimumHeight={300}
                        totalCount={catalog?.count}
                        overFlowClass="overflow-auto"
                        handleSortChange={handleSortChange}
                        initialSortField={currentParams?.SortDto?.Field}
                        initialSortOrder={currentParams?.SortDto?.Order}
                        isLoading={loading}
                    />
                )}
                {dropdownOption?.id === CatalogType?.DRProtectors?.toString() && (
                    <InfiniteScrollTable
                        data={catalog?.data || []}
                        columns={[...DrProtectors]}
                        onLoadMore={() => loadMore()}
                        rowsPerPage={1}
                        minimumHeight={300}
                        totalCount={catalog?.count}
                        overFlowClass="overflow-auto"
                        handleSortChange={handleSortChange}
                        initialSortField={currentParams?.SortDto?.Field}
                        initialSortOrder={currentParams?.SortDto?.Order}
                        isLoading={loading}
                    />
                )}
                {dropdownOption?.id === CatalogType?.DRPumps?.toString() && (
                    <InfiniteScrollTable
                        data={catalog?.data || []}
                        columns={[...DrPumps]}
                        onLoadMore={() => loadMore()}
                        rowsPerPage={1}
                        minimumHeight={300}
                        totalCount={catalog?.count}
                        overFlowClass="overflow-auto"
                        handleSortChange={handleSortChange}
                        initialSortField={currentParams?.SortDto?.Field}
                        initialSortOrder={currentParams?.SortDto?.Order}
                        isLoading={loading}
                    />
                )}
                {dropdownOption?.id === CatalogType?.DRSwitchBoard?.toString() && (
                    <InfiniteScrollTable
                        data={catalog?.data || []}
                        columns={[...DrSwitchBoard]}
                        onLoadMore={() => loadMore()}
                        rowsPerPage={1}
                        minimumHeight={300}
                        totalCount={catalog?.count}
                        overFlowClass="overflow-auto"
                        handleSortChange={handleSortChange}
                        initialSortField={currentParams?.SortDto?.Field}
                        initialSortOrder={currentParams?.SortDto?.Order}
                        isLoading={loading}
                    />
                )}
                {dropdownOption?.id === CatalogType?.DRVSD?.toString() && (
                    <InfiniteScrollTable
                        data={catalog?.data || []}
                        columns={[...DrVSD]}
                        onLoadMore={() => loadMore()}
                        rowsPerPage={1}
                        minimumHeight={300}
                        totalCount={catalog?.count}
                        overFlowClass="overflow-auto"
                        handleSortChange={handleSortChange}
                        initialSortField={currentParams?.SortDto?.Field}
                        initialSortOrder={currentParams?.SortDto?.Order}
                        isLoading={loading}
                    />
                )}
                {dropdownOption?.id === CatalogType?.SRAccAboveESP?.toString() && (
                    <InfiniteScrollTable
                        data={catalog?.data || []}
                        columns={[...SrAccAboveESP]}
                        onLoadMore={() => loadMore()}
                        rowsPerPage={1}
                        minimumHeight={300}
                        totalCount={catalog?.count}
                        overFlowClass="overflow-auto"
                        handleSortChange={handleSortChange}
                        initialSortField={currentParams?.SortDto?.Field}
                        initialSortOrder={currentParams?.SortDto?.Order}
                        isLoading={loading}
                    />
                )}
                {dropdownOption?.id === CatalogType?.SRAccBelowESP?.toString() && (
                    <InfiniteScrollTable
                        data={catalog?.data || []}
                        columns={[...SrAccBelowESP]}
                        onLoadMore={() => loadMore()}
                        rowsPerPage={1}
                        minimumHeight={300}
                        totalCount={catalog?.count}
                        overFlowClass="overflow-auto"
                        handleSortChange={handleSortChange}
                        initialSortField={currentParams?.SortDto?.Field}
                        initialSortOrder={currentParams?.SortDto?.Order}
                        isLoading={loading}
                    />
                )}
                {dropdownOption?.id === CatalogType?.SRBOH?.toString() && (
                    <InfiniteScrollTable
                        data={catalog?.data || []}
                        columns={[...SrBOH]}
                        onLoadMore={() => loadMore()}
                        rowsPerPage={1}
                        minimumHeight={300}
                        totalCount={catalog?.count}
                        overFlowClass="overflow-auto"
                        handleSortChange={handleSortChange}
                        initialSortField={currentParams?.SortDto?.Field}
                        initialSortOrder={currentParams?.SortDto?.Order}
                        isLoading={loading}
                    />
                )}
                {dropdownOption?.id === CatalogType?.SRCables?.toString() && (
                    <InfiniteScrollTable
                        data={catalog?.data || []}
                        columns={[...SrCables]}
                        onLoadMore={() => loadMore()}
                        rowsPerPage={1}
                        minimumHeight={300}
                        totalCount={catalog?.count}
                        overFlowClass="overflow-auto"
                        handleSortChange={handleSortChange}
                        initialSortField={currentParams?.SortDto?.Field}
                        initialSortOrder={currentParams?.SortDto?.Order}
                        isLoading={loading}
                    />
                )}
                {dropdownOption?.id === CatalogType?.SRGasHandlers?.toString() && (
                    <InfiniteScrollTable
                        data={catalog?.data || []}
                        columns={[...SrGasHandlers]}
                        onLoadMore={() => loadMore()}
                        rowsPerPage={1}
                        minimumHeight={300}
                        totalCount={catalog?.count}
                        overFlowClass="overflow-auto"
                        handleSortChange={handleSortChange}
                        initialSortField={currentParams?.SortDto?.Field}
                        initialSortOrder={currentParams?.SortDto?.Order}
                        isLoading={loading}
                    />
                )}
                {dropdownOption?.id === CatalogType?.SRGasSeparators?.toString() && (
                    <InfiniteScrollTable
                        data={catalog?.data || []}
                        columns={[...SrGasSeparators]}
                        onLoadMore={() => loadMore()}
                        rowsPerPage={1}
                        minimumHeight={300}
                        totalCount={catalog?.count}
                        overFlowClass="overflow-auto"
                        handleSortChange={handleSortChange}
                        initialSortField={currentParams?.SortDto?.Field}
                        initialSortOrder={currentParams?.SortDto?.Order}
                        isLoading={loading}
                    />
                )}
                {dropdownOption?.id === CatalogType?.SRMLE?.toString() && (
                    <InfiniteScrollTable
                        data={catalog?.data || []}
                        columns={[...SrMLE]}
                        onLoadMore={() => loadMore()}
                        rowsPerPage={1}
                        minimumHeight={300}
                        totalCount={catalog?.count}
                        overFlowClass="overflow-auto"
                        handleSortChange={handleSortChange}
                        initialSortField={currentParams?.SortDto?.Field}
                        initialSortOrder={currentParams?.SortDto?.Order}
                        isLoading={loading}
                    />
                )}
                {dropdownOption?.id === CatalogType?.SRMotors?.toString() && (
                    <InfiniteScrollTable
                        data={catalog?.data || []}
                        columns={[...SrMotors]}
                        onLoadMore={() => loadMore()}
                        rowsPerPage={1}
                        minimumHeight={300}
                        totalCount={catalog?.count}
                        overFlowClass="overflow-auto"
                        handleSortChange={handleSortChange}
                        initialSortField={currentParams?.SortDto?.Field}
                        initialSortOrder={currentParams?.SortDto?.Order}
                        isLoading={loading}
                    />
                )}
                {dropdownOption?.id === CatalogType?.SRProtectors?.toString() && (
                    <InfiniteScrollTable
                        data={catalog?.data || []}
                        columns={[...SrProtectors]}
                        onLoadMore={() => loadMore()}
                        rowsPerPage={1}
                        minimumHeight={300}
                        totalCount={catalog?.count}
                        overFlowClass="overflow-auto"
                        handleSortChange={handleSortChange}
                        initialSortField={currentParams?.SortDto?.Field}
                        initialSortOrder={currentParams?.SortDto?.Order}
                        isLoading={loading}
                    />
                )}
                {dropdownOption?.id === CatalogType?.SRPumps?.toString() && (
                    <InfiniteScrollTable
                        data={catalog?.data || []}
                        columns={[...SrPumps]}
                        onLoadMore={() => loadMore()}
                        rowsPerPage={1}
                        minimumHeight={300}
                        totalCount={catalog?.count}
                        overFlowClass="overflow-auto"
                        handleSortChange={handleSortChange}
                        initialSortField={currentParams?.SortDto?.Field}
                        initialSortOrder={currentParams?.SortDto?.Order}
                        isLoading={loading}
                    />
                )}
                {dropdownOption?.id === CatalogType?.SRTransformers?.toString() && (
                    <InfiniteScrollTable
                        data={catalog?.data || []}
                        columns={[...SrTransformers]}
                        onLoadMore={() => loadMore()}
                        rowsPerPage={1}
                        minimumHeight={300}
                        totalCount={catalog?.count}
                        overFlowClass="overflow-auto"
                        handleSortChange={handleSortChange}
                        initialSortField={currentParams?.SortDto?.Field}
                        initialSortOrder={currentParams?.SortDto?.Order}
                        isLoading={loading}
                    />
                )}
                {dropdownOption?.id === CatalogType?.SRVSDs?.toString() && (
                    <InfiniteScrollTable
                        data={catalog?.data || []}
                        columns={[...SrVSDs]}
                        onLoadMore={() => loadMore()}
                        rowsPerPage={1}
                        minimumHeight={300}
                        totalCount={catalog?.count}
                        overFlowClass="overflow-auto"
                        handleSortChange={handleSortChange}
                        initialSortField={currentParams?.SortDto?.Field}
                        initialSortOrder={currentParams?.SortDto?.Order}
                        isLoading={loading}
                    />
                )}
                {dropdownOption?.id === CatalogType?.HarmonicFilters?.toString() && (
                    <InfiniteScrollTable
                        data={catalog?.data || []}
                        columns={[...HarmonicFilters]}
                        onLoadMore={() => loadMore()}
                        rowsPerPage={1}
                        minimumHeight={300}
                        totalCount={catalog?.count}
                        overFlowClass="overflow-auto"
                        handleSortChange={handleSortChange}
                        initialSortField={currentParams?.SortDto?.Field}
                        initialSortOrder={currentParams?.SortDto?.Order}
                        isLoading={loading}
                    />
                )}
            </div>
        </div>
    );
};

export default Catalog;
